export default __webpack_public_path__ + "static/media/bannerimg.462272c9.png";